export default "__VITE_ASSET__wPAwqswA__"